import { render, staticRenderFns } from "./AICoach.vue?vue&type=template&id=e12994f4&scoped=true&"
import script from "./AICoach.vue?vue&type=script&lang=js&"
export * from "./AICoach.vue?vue&type=script&lang=js&"
import style0 from "./AICoach.vue?vue&type=style&index=0&id=e12994f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12994f4",
  null
  
)

export default component.exports